import { render, staticRenderFns } from "./InStatistic.vue?vue&type=template&id=5820ad62&scoped=true&"
import script from "./InStatistic.vue?vue&type=script&lang=js&"
export * from "./InStatistic.vue?vue&type=script&lang=js&"
import style0 from "./InStatistic.vue?vue&type=style&index=0&id=5820ad62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820ad62",
  null
  
)

export default component.exports